import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { OrderDeliveryTab } from "./DeliveryOrderType/OrderDeliveryTab";
import styleClasses from "./ItemGrid.module.scss";
import OrderPickupTab from "./PickupOrderType/OrderPickupTab";
import { DELIVERY_ORDER_TYPE, PICK_UP_ORDER_TYPE, ROUTE_CHECKOUT } from "../../constants";
import { useAppSelector } from "../../redux/store/store";
import { IItemPathToRoute } from "../../models/item.model";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import OrderPickupTabV2 from "./PickupOrderType/OrderPickupTabV2";
import { useIsDesignV2 } from "../../hooks/useIsDesignV2";
import { PULSE_VIEW_ID, trackPulseView } from "../../analytics/pulseViewIds";
import type { OrderTypeModalSource } from "../../analytics/pulseSelectOrderTypeClick";

//refactored code
interface IOrderTypeProps {
  itemPath?: IItemPathToRoute;
  handleOrderTypeModal?: () => void;
  changeToDelivery?: boolean;
  handleShowDeliveryMethodModal?: (boolean) => void;
  changeToPickup?:boolean;
  handleShowPickupMethodModal?: (boolean) => void;
  editAddressOnCheckout?: any;
  modalSource?: OrderTypeModalSource;
}
const OrderType = (props: IOrderTypeProps) => {
  const { 
    itemPath, 
    handleOrderTypeModal, 
    changeToDelivery,
    handleShowDeliveryMethodModal,
    changeToPickup,
    handleShowPickupMethodModal,
    editAddressOnCheckout,
    modalSource,
  } = props;

  const selectedOrderType = useAppSelector((state) => state.cart?.orderType || "" );
  const LocationFlow = useAppSelector(
    (state) => state.Items.LocationFlow
  );
  const [showOrderTypeGrid, setShowOrderTypeGrid] = useState<boolean>(true);
  const [isNearestStoreAvailable, setIsNearestStoreAvailable] = useState<boolean>(true);
  const [showItemDeliveryDateTime , setShowItemDeliveryDateTime] = useState(false);
  const [showItemPickupDateTime , setShowItemPickupDateTime] = useState(false);
  const [ saveSelectedOrderType , setSelectedOrderType] =useState<string>(selectedOrderType || PICK_UP_ORDER_TYPE);
  const isItMobile = useCheckMobileScreen()
  const location = useLocation();
  const isDesignV2 = useIsDesignV2();

  useEffect(() => {
    trackPulseView(PULSE_VIEW_ID.LOCATION_SELECTOR_MODAL, {
      page_path: location.pathname,
    });
    // Mount-only: modal open = OrderType mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOrderType = (orderType: string) => {
    setSelectedOrderType(orderType);
  };

  const handleOrderTypeSelect = (orderType: string) => {
    if (orderType === saveSelectedOrderType) return;
    setSelectedOrderType(orderType);
  };

  const showItemDeliveryDateTimeModalMethod = () => {
    handleShowDeliveryMethodModal(true)
  }
  const showItemPickupDateTimeModalMethod = () => {
    handleShowPickupMethodModal && handleShowPickupMethodModal(true)
  }
  useEffect(()=>{
    if(changeToDelivery && handleShowDeliveryMethodModal){
      setShowItemDeliveryDateTime(true)
    }
    if(changeToDelivery){
      handleOrderType(DELIVERY_ORDER_TYPE)
    }
  }, [changeToDelivery])

  useEffect(()=>{
    if(changeToPickup){
      setShowItemPickupDateTime(true)
      handleOrderType(PICK_UP_ORDER_TYPE)
    }
  }, [changeToPickup])

  const getDefaultKey = () => {
    return changeToPickup ? PICK_UP_ORDER_TYPE : changeToDelivery ? DELIVERY_ORDER_TYPE : saveSelectedOrderType
  }
  return (
    <div
      className={`${styleClasses.order_pickup_wrapper} order-pickup-wrapper`}
    >
      {
          <h5 className={`f-s20 pb-4 font-Cls text-center fw-normal text-capitalize`} style={{marginTop: "-12px"}}>
            Select Your Order Type
          </h5>
      }

        <Tab.Container defaultActiveKey={getDefaultKey()}>
              <>
                <Nav variant="pills" className="d-flex justify-content-center">
                  <Nav.Item>
                    <Nav.Link
                        eventKey={PICK_UP_ORDER_TYPE}
                        className={`${styleClasses.order_type} px-4 ${editAddressOnCheckout && styleClasses.nav_disabled}`}
                        onClick={() => handleOrderTypeSelect(PICK_UP_ORDER_TYPE)}
                        disabled={editAddressOnCheckout}
                    >
                      Pick-Up
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={!isNearestStoreAvailable ? "too-far-Location" : "" }>
                    <Nav.Link
                        eventKey={DELIVERY_ORDER_TYPE}
                        className={`${styleClasses.order_type} mx-2 `}
                        onClick={() => handleOrderTypeSelect(DELIVERY_ORDER_TYPE)}
                    >
                      Delivery
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                {
                  editAddressOnCheckout ? <div className="clr-dark-red f-s14 text-center pt-2">You can't change order type here.</div> : null
                }
              </>
          <Tab.Content>
            <Tab.Pane eventKey={PICK_UP_ORDER_TYPE}>
              <OrderPickupTabV2
              itemPath={itemPath ?? LocationFlow?.intendedPath} 
              handleOrderTypeModal={handleOrderTypeModal}  
              showItemPickupDateTime={showItemPickupDateTime}
              handleShowPickupMethodModal={showItemPickupDateTimeModalMethod}
              saveSelectedOrderType={saveSelectedOrderType}
              isItMobile={isItMobile}
              selectedOrderType={selectedOrderType}
              modalSource={modalSource}
              />
            </Tab.Pane>
            <Tab.Pane eventKey={DELIVERY_ORDER_TYPE}>
              <div className={`px-2`}>
              {
                showOrderTypeGrid ?
                    <p className={`text-center f-s14 pb-0 mt-3 mb-2 ${isDesignV2 ? 'ls-05 f-w4  clr-dark-grey' : ''}`}>
                      Some items cannot be delivered.
                    </p> : null
              }
              <OrderDeliveryTab
                  itemPath={itemPath ?? LocationFlow?.intendedPath} 
                  setShowOrderTypeGrid={setShowOrderTypeGrid}
                  handleOrderTypeModal={handleOrderTypeModal}
                  isNearestStoreAvailable={isNearestStoreAvailable}
                  setIsNearestStoreAvailable={setIsNearestStoreAvailable}
                  showItemDeliveryDateTime={showItemDeliveryDateTime}
                  handleShowDeliveryMethodModal={showItemDeliveryDateTimeModalMethod}
                  saveSelectedOrderType={saveSelectedOrderType}
                  handleOrderType={handleOrderType}
                  isItMobile={isItMobile}
                  isCheckout={location.pathname.includes(ROUTE_CHECKOUT)}
                  showOrderTypeGrid={showOrderTypeGrid}
                  modalSource={modalSource}
              />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
    </div>
  );
};

export default OrderType;
